import {css} from "@emotion/react";
import styled from "@emotion/styled";

interface IProps {
    position: "top" | "bottom";
    zIndex?: number;
    height?: string;
}

export const ReelDetailsApla = styled.div<IProps>`
    position: absolute;
    z-index: ${({zIndex}) => zIndex || 1};
    inset: auto 0;
    height: ${({height}) => height || "30%"};

    ${({position}) =>
        position === "top"
            ? css`
                  top: 0;
                  background: linear-gradient(${APLA_GRADIENT_COLORS.OUTSIDE}, ${APLA_GRADIENT_COLORS.INSIDE});
              `
            : css`
                  bottom: 0;
                  background: linear-gradient(${APLA_GRADIENT_COLORS.INSIDE}, ${APLA_GRADIENT_COLORS.OUTSIDE});
              `};
`;

export const APLA_GRADIENT_COLORS = {
    OUTSIDE: "rgba(35, 35, 45, 1)",
    INSIDE: "rgba(255, 255, 255, 0)"
};
import {css} from "@emotion/react";
import styled from "@emotion/styled";

interface IProps {
    position: "top" | "bottom";
    zIndex?: number;
    height?: string;
}

export const ReelDetailsApla = styled.div<IProps>`
    position: absolute;
    z-index: ${({zIndex}) => zIndex || 1};
    inset: auto 0;
    height: ${({height}) => height || "30%"};

    ${({position}) =>
        position === "top"
            ? css`
                  top: 0;
                  background: linear-gradient(${APLA_GRADIENT_COLORS.OUTSIDE}, ${APLA_GRADIENT_COLORS.INSIDE});
              `
            : css`
                  bottom: 0;
                  background: linear-gradient(${APLA_GRADIENT_COLORS.INSIDE}, ${APLA_GRADIENT_COLORS.OUTSIDE});
              `};
`;

export const APLA_GRADIENT_COLORS = {
    OUTSIDE: "rgba(35, 35, 45, 1)",
    INSIDE: "rgba(255, 255, 255, 0)"
};
